import Swiper, {
  Navigation,
  Pagination,
  Scrollbar,
  Virtual,
  A11y,
  SwiperOptions,
  EffectFade,
  Autoplay
} from 'swiper';
import { useRef, useEffect } from 'react';
import './Swiper.scss';

Swiper.use([EffectFade, Navigation, Pagination, Scrollbar, Virtual, A11y, Autoplay]);

export const useSwiper = (selector: string | HTMLElement | null, configuration: SwiperOptions) => {
  const swiper = useRef<Swiper>();

  useEffect(() => {
    if (selector) {
      swiper.current = new Swiper(selector, configuration);
    }
  }, [configuration, selector]);

  return swiper;
};
